/**
 * Created by moshemal on 9/4/14.
 */
define(['base/jsUtils'], function(jsUtils){
	'use strict'
	return jsUtils;
});